export interface User {
  level: number;
  name: string;
  steamid: string;
  avatar: string;
  xp?: number;
  xpNeeded?: number;
  admin?: number;
  role?: number;
}

export interface UserStats {
  trade_url: string;
  coinflip_amounts: number;
  coinflip_bets: number;
  coinflip_skins: number;
  coinflip_won: number;
  jackpot_amounts: number;
  jackpot_bets: number;
  jackpot_skins: number;
  jackpot_won: number;
  profile_privacy: 1 | 0;
  registered: number;
}

export enum UserProfileWagersEnum {
  'Coinflip',
  'Jackpot',
  'King',
  'Mines',
  'Plinko',
  'Towers',
  'Upgrader',
  'Wheel',
  'CaseOpening',
  'CaseBattles',
}

enum UserProfileRewardsEnum {
  'rain',
  'cashback',
  'supply',
  'faucet',
  'case',
  'balance',
}

export interface UserProfile {
  wagers: {
    [key in keyof typeof UserProfileWagersEnum]: number;
  };
  rewards: {
    [key in keyof typeof UserProfileRewardsEnum]: number;
  };
  favorite: null | keyof typeof UserProfileWagersEnum;
  favorite_case: {
    image: string | null;
    name: string | null;
    opens?: number;
  };
  luckiest: {
    game: null | string;
    multiplier: number;
    won: number;
  };
  registered: number;
}

export const WAGER_NAMES: Record<keyof UserProfile['wagers'], string> = {
  Coinflip: 'Coinflip',
  Jackpot: 'Jackpot',
  King: 'King',
  Mines: 'Mines',
  Plinko: 'Plinko',
  Towers: 'Tower',
  Upgrader: 'Upgrade',
  Wheel: 'Wheel',
  CaseOpening: 'Case',
  CaseBattles: 'Case Battles',
};

export const REWARD_NAMES: Record<keyof UserProfile['rewards'], string> = {
  balance: 'Wager Goals',
  cashback: 'Rakeback',
  case: 'Daily Cases',
  faucet: 'Faucet',
  rain: 'Rain',
  supply: 'Supply Drop',
};
